// External libraries
import React, { useContext } from 'react';

// BWA stuff
import { SignUpFormContext } from './SignUpFormProvider';
import SignUpFormView from './SignUpFormView';

const SignUpFormContainer = props => {
    const formContext = useContext(SignUpFormContext);

    const viewProps = {
        ...props,
        ...formContext,
    };

    return <SignUpFormView {...viewProps} />;
};

export default SignUpFormContainer;
